import { useSyncExternalStore } from 'react';

export enum OnlineStatus {
  Online = 'online',
  Offline = 'offline',
}

const subscribe = (onStatusChange: () => void) => {
  window.addEventListener('online', onStatusChange);
  window.addEventListener('offline', onStatusChange);
  return () => {
    window.removeEventListener('online', onStatusChange);
    window.removeEventListener('offline', onStatusChange);
  };
};

const getStatus = () => (window.navigator.onLine ? OnlineStatus.Online : OnlineStatus.Offline);

// Read straight from navigator.onLine, so the first render already has the real status.
const useOnlineStatus = (): OnlineStatus => useSyncExternalStore(subscribe, getStatus);

export default useOnlineStatus;
